import { AxiosResponse } from 'axios';
import { axiosBaseInstance } from './config';
import { UserPostFields } from './../redux/types/userTypes';

interface User {
  name: string;
}

const createUser = async (
  postFields: UserPostFields,
  activation_code: string,
  term_id: number
): Promise<any> => {
  const response: AxiosResponse<User[]> = await axiosBaseInstance({
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `/users`,
    data: {
      user: { ...postFields },
      activation_code,
      term_id,
    },
  });
  return response?.data;
};

const isRegistered = async (rut: string): Promise<any> => {
  const response: AxiosResponse<User[]> = await axiosBaseInstance({
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `/is_registered`,
    data: {
      rut,
    },
  });
  return response?.data;
};

const phoneIsRegistered = async (phone: string): Promise<any> => {
  const response: AxiosResponse<User[]> = await axiosBaseInstance({
    headers: { 'Content-Type': 'application/json' },
    method: 'post',
    url: `/phone_is_registered`,
    data: {
      phone,
    },
  });
  return response?.data;
};

const userService = {
  createUser,
  isRegistered,
  phoneIsRegistered,
};

export default userService;
